import { DashboardFilterStore, ReturnFilterStore } from 'zustand-store';
import { Hamburger } from 'components';
import {
  DashboardMoreFilter,
  DashboardSearch,
  ReturnMoreFilter,
  ReturnSearch,
} from './components';
import * as S from './styles';

export function DashboardFilter() {
  const { filteredStore } = DashboardFilterStore.useStore();

  return (
    <S.Filter key={filteredStore}>
      <Hamburger />

      <DashboardSearch />

      <DashboardMoreFilter />
    </S.Filter>
  );
}

export function ReturnFilter() {
  const { filteredStore } = ReturnFilterStore.useStore();

  return (
    <S.Filter key={filteredStore}>
      <Hamburger />

      <ReturnSearch />

      <ReturnMoreFilter />
    </S.Filter>
  );
}
